<template>
  <div>
    <Modal :visible="visible" @ok="visible = false" @cancel="visible = false">
      <a-card :bordered="false">
        <div class="input-title">部屋数と人数を変更</div>
        <div class="block1">
          <div class="input-name-title">部屋数</div>
          <Stepper class="counter" size="large" unit="部屋"/>
        </div>
        <div class="block2">
          <div class="input-name-title">1部屋ご利用人数</div>
          <div class="add-people">
            <div class="label-name">大人</div>
            <Stepper class="counter" size="large" unit="人"/>
          </div>
          <div class="changeValue__choose-children">
            <div class="label-name-choose">子ども</div>
            <a-popover v-model="showPopover" trigger="click" class="children-attach" style="background-color: #F2F2F2 ; max-width: 500px">
              <a-input class="input-value-children" size="large" :value="`${countTotalChildren} 人`" />
              <div slot="content" class="children-attach-content" >
                <div class="popover-block-first">
                  <div class="block-first-title">小学生</div>
                  <div class="block-first-content">
                    <div class="set-value-group">
                      <div class="set-value-name">高学年</div>
                      <Stepper v-model="childrenType1" size="large" unit="人"/>
                    </div>
                    <div class="set-value-group">
                      <div class="set-value-name">低学年</div>
                      <Stepper v-model="childrenType2" size="large" unit="人"/>
                    </div>
                  </div>
                </div>
                <div class="popover-block-second">
                  <div class="block-second-title">幼児</div>
                  <div class="block-second-content">
                    <div class="set-value-group">
                      <div class="set-value-name">食事・布団付</div>
                      <Stepper v-model="childrenType3" size="large" unit="人"/>
                    </div>
                    <div class="set-value-group">
                      <div class="set-value-name">食事のみ</div>
                      <Stepper v-model="childrenType4" size="large" unit="人"/>
                    </div>
                  </div>
                </div>
                <div class="popover-block-three">
                  <div class="block-three-content">
                    <div class="set-value-group">
                      <div class="set-value-name">布団のみ</div>
                      <Stepper v-model="childrenType5" size="large" unit="人"/>
                    </div>
                    <div class="set-value-group">
                      <div class="set-value-name">食事・布団不要</div>
                      <Stepper v-model="childrenType6" size="large" unit="人"/>
                    </div>
                  </div>
                </div>
              </div>
            </a-popover>
          </div>
        </div>

        <Button class="submit-btn" >この条件で検索する（000件）</Button>
      </a-card>
    </Modal>
  </div>
</template>

<script>
import { Button, Modal, Stepper } from '@/components/primitive'

export default {
  name: 'ChildrenAttach',
  components: {
    Button,
    Modal,
    Stepper
  },
  data() {
    return {
      visible: false,
      showPopover: false,
      childrenType1: 0,
      childrenType2: 0,
      childrenType3: 0,
      childrenType4: 0,
      childrenType5: 0,
      childrenType6: 0,
      number_input1: [0, 0, 0, 0, 0, 0]
    }
  },
  computed: {
    countTotalChildren() {
      return this.childrenType1 + this.childrenType2 + this.childrenType3 + this.childrenType4 + this.childrenType5 + this.childrenType6
    }
  },
  methods: {
    sumPeople() {
      return this.number_input1.reduce((total, e) => total + e, 0)
    },
    onChangeChild(value) {
      this.number_input1[parseInt(value.id)] = value.children
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./style.scss";
/deep/ .popover-contain {
  width: 450px;
}
</style>
